export interface IBuildPhasePhotoFile {
  buildCommunicationPhotoFileId: number;
  photoUrl: string;
  originalFileName: string;
  contentType: string | null;
  fileSize: number;
  createdAt: string;
  createdBy: string;
}

export interface IBuildPhasePhoto {
  buildCommunicationPhotosId: number;
  comment: string;
  createdAt: string;
  createdBy: string;
  photoFiles: IBuildPhasePhotoFile[];
}

// Interface for flattened photo items that will be displayed in the carousel
export interface IFlattenedPhotoItem extends IBuildPhasePhotoFile {
  comment?: string; // Only the first photo in each group will have a comment
}

export interface IBuildPhasePhotosQueryParams {
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number;
}

export interface IBuildMessages {
  buildCommunicationMessagesId: number;
  createdAt: string;
  createdBy: string;
  createdByFullName: string;
  fileUrl: string | null;
  fileType: string;
  message: string;
  messageSource: MessageSource;
}

export interface IBuildMessagesQueryParams {
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number;
}

export enum MessageSource {
  Internal = 'Internal',
  Purchaser = 'Purchaser'
}
